import { initAuthTabs } from './_tabs'
import { AuthController } from './_controller'

/**
 * Инициализирует страницу авторизации.
 * Создает контроллер авторизации и инициализирует вкладки, если найден контейнер авторизации.
 *
 * @return {void}
 */
export function initAuthPage() {
  const authContainer = document.querySelector<HTMLElement>(
    '[data-auth-controller]'
  )

  if (authContainer) {
    new AuthController(authContainer).init()
    initAuthTabs()
  }
}
